module.exports = __webpack_public_path__ + "assets-cabinet/img/a_check--green.59431685.svg";